module.exports = __webpack_public_path__ + "static/media/rack-1.885dada7.jpg";